"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistance = ([x1, y1], [x2, y2]) => {
    const sum = Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2);
    return Math.sqrt(sum);
};
//# sourceMappingURL=distance.js.map